import { writable } from "svelte/store"
import { updateHtmlClass } from "@utils/directives/useCSSObserver"

export const expanded = writable(false)

expanded.subscribe((expanded) => updateHtmlClass("expanded", expanded))

// @ts-ignore
window.expand = () => expanded.set(true)
// @ts-ignore
window.contract = () => expanded.set(false)
